export var MonthGroup;
(function (MonthGroup) {
    function create(transactions) {
        let result = new Map();
        return transactions
            ? transactions.reduce((r, c) => MonthGroup.add(r, c), result)
            : result;
    }
    MonthGroup.create = create;
    function add(group, tx) {
        const month = tx.date.substring(0, 7);
        const catGroup = group.get(month);
        if (!catGroup)
            group.set(month, CategoryGroup.create([tx]));
        else
            CategoryGroup.add(catGroup, tx);
        return group;
    }
    MonthGroup.add = add;
})(MonthGroup || (MonthGroup = {}));
export var CategoryGroup;
(function (CategoryGroup) {
    function create(transactions) {
        let result = new Map();
        return transactions ? transactions.reduce((r, c) => CategoryGroup.add(r, c), result) : result;
    }
    CategoryGroup.create = create;
    function add(group, tx) {
        var _a, _b;
        const category = (_a = tx.category) !== null && _a !== void 0 ? _a : "undefined";
        return group.set(category, [...(_b = group.get(category)) !== null && _b !== void 0 ? _b : [], tx]);
    }
    CategoryGroup.add = add;
})(CategoryGroup || (CategoryGroup = {}));
